import { httpClient } from '@/infra/protocols/http';
import { IPodcastDetailsDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcastDetails } from '@/modules/podcasts/entities/podcast.entity';
import { PodcastDetailsMapper } from '@/modules/podcasts/mappers/podcast-details.mapper';

export async function getPodcastDetails(
  params: GetPodcastDetailsService.Params,
): Promise<GetPodcastDetailsService.Response> {
  const response = await httpClient.get<IPodcastDetailsDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}`,
  );
  return PodcastDetailsMapper.toPresentation(response);
}

export namespace GetPodcastDetailsService {
  export interface Params {
    projectId: string;
    podcastId: string;
  }

  export type Response = IPodcastDetails;
}
